export default "__VITE_ASSET__4fa8e56c__"